import { createUseStyles } from '@glu/theming';

/* istanbul ignore next */
const useStyles = createUseStyles(
  ({
    palette: {
      grey: { G600 }
    },
    spacing: { unit },
    typography
  }) => ({
    default: {
      fontFamily: typography.fontFamily,
      fontSize: typography.fontSize
    },
    title: typography.title,
    mainTitle: typography.mainTitle,
    headline1: typography.headline1,
    headline2: typography.headline2,
    headline3: typography.headline3,
    largeLabel: typography.largeLabel,
    smallLabel: { ...typography.smallLabel, color: G600 },
    linkTitle: typography.linkTitle,
    subtitle: typography.subtitle,
    disclaimer: {
      fontSize: `${unit * 1.5}px`
    },
    light: {
      fontWeight: typography.fontWeightLight
    },
    regular: {
      fontWeight: typography.fontWeightRegular
    },
    medium: {
      fontWeight: typography.fontWeightMedium
    },
    heavy: {
      fontWeight: typography.fontWeightHeavy
    }
  })
);

export default useStyles;
